type Data = { [k: string]: string };

// generate CSV file from data
export const generateCSV = (data: Data[], columns: string[]): string => {
  const headers = columns.join(",");
  const rows = data
    .map((item) => columns.map((column) => item[column]).join(","))
    .join("\n");
  return `${headers}\n${rows}`;
};
